module.exports = __webpack_public_path__ + "img/49.7b08831f.jpg";